import BaseModelAPI from '../BaseModelAPI';

export default class DeliveryInstructionSubcontractDetail extends BaseModelAPI {
	static entity = 'deliveryinstructionsubcontractdetail';
	static entityName = 'deliveryinstructionsubcontractdetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.deliveryInstructionSubcontractId = '';
			this.deliveryInstructionSubcontract = {};
			this.partId = '';
			this.part = {};
			this.partName = '';
			this.qtyDelivery = 0;
			this.deliveryOrderDetailId = '';
			this.deliveryOrderDetail = {};
			this.isNeedRegenerateDc = false;
			this.qtyActualSupply = 0;
			this.qtyOutstanding = 0;
			this.deliveryInstructionStatusId = '';
			this.deliveryInstructionStatus = {};
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}